function Comp23() {
    $(".comp-23").each(function () {
        const $comp = $(this);

        const captions = $comp
            .find(".swiper-slide")
            .map(function () {
                return $(this).attr("data-caption") || "";
            })
            .get();

        const swiper = new Swiper($comp.find(".swiper")[0], {
            slidesPerView: "auto",
            spaceBetween: 24,
            centeredSlides: true,
            speed: 600,
            on: {
                slideChange: function () {
                    const captionText = captions[this.activeIndex] || "";
                    $comp.find(".swiper-caption p").text(captionText);
                },
            },
        });

        const initialCaption = captions[swiper.activeIndex] || "";
        $comp.find(".swiper-caption p").text(initialCaption);
    });
}

Comp23();
